class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  updateCartBasedOnKit(variantId) {
    // Fetch the current state of the cart
    var checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.classList.add('disabled');
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let hasKit = false;
        let isProduct = false;
        let productQuantity = 0;
        let quantity = 0;
  
        // Loop through the cart items to determine if the "Free book" is present
        cart.items.forEach(item => {
          if (item.properties) {
            for (let [propertyName, propertyValue] of Object.entries(item.properties)) {
              if (propertyName === 'Promoción' && propertyValue === 'Gratis Tote') {
                hasKit = true;
                productQuantity += item.quantity;
              }
            }
          }
        });
  
        // Loop through the cart items to check for the target product
        cart.items.forEach(item => {
          if (item.variant_id == variantId) {
            isProduct = true;
            quantity += item.quantity;
          }
        });
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        };
  
        // Perform actions based on the kit and product presence
        if (hasKit) {
          if (!isProduct) {
            // Add product to cart if it is not already there
            const formData = new FormData();
            formData.append('quantity', 1);
            formData.append('id', variantId);
  
            // Add sections to render if available (theme specific behavior)
            const sections = this.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
            
            config.body = formData;
  
            fetch('/cart/add.js', config)
              .then(response => response.json())
              .then(response => {
                if (response.status) {
                  console.error('Error adding product:', response.description);
                  return;
                } else {
                  this.renderContents(response);
                }
                var checkoutButton = document.querySelector('#CartDrawer-Checkout');
                if (checkoutButton) {
                  checkoutButton.disabled = false;
                  checkoutButton.classList.remove('disabled');
                }
              })
              .catch(error => console.error('Error adding product:', error));
          } else if (quantity !== productQuantity) {
            // Update the product quantity to match with the kit
            /*const formData = new FormData();
            formData.append('updates[' + variantId + ']', productQuantity);
  
            // Add sections to render if available (theme specific behavior)
            const sections = this.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
            
            config.body = formData;
  
            fetch('/cart/update.js', config)
              .then(response => response.json())
              .then(response => {
                if (response.status) {
                  console.error('Error updating cart:', response.description);
                } else {
                  this.renderContents(response);
                }
                var checkoutButton = document.querySelector('#CartDrawer-Checkout');
                if (checkoutButton) {
                  checkoutButton.disabled = false;
                  checkoutButton.classList.remove('disabled');
                }
              })
              .catch(error => console.error('Error updating cart:', error));*/
           var checkoutButton = document.querySelector('#CartDrawer-Checkout');
                if (checkoutButton) {
                  checkoutButton.disabled = false;
                  checkoutButton.classList.remove('disabled');
                }
          }
          var checkoutButton = document.querySelector('#CartDrawer-Checkout');
                if (checkoutButton) {
                  console.log('enable');
                  checkoutButton.disabled = false;
                  checkoutButton.classList.remove('disabled');
                }
        } else {
          if (quantity > 0) {
            // Remove the product from cart if it is no longer part of the kit
            const formData = new FormData();
            formData.append('updates[' + variantId + ']', 0);
  
            // Add sections to render if available (theme specific behavior)
            const sections = this.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
            
            config.body = formData;
  
            fetch('/cart/update.js', config)
              .then(response => response.json())
              .then(response => {
                if (response.status) {
                  console.error('Error removing product:', response.description);
                } else {
                   this.renderContents(response);
                }
                var checkoutButton = document.querySelector('#CartDrawer-Checkout');
                if (checkoutButton) {
                  checkoutButton.disabled = false;
                  checkoutButton.classList.remove('disabled');
                }
              })
              .catch(error => console.error('Error removing product:', error));
          }else{
            var checkoutButton = document.querySelector('#CartDrawer-Checkout');
            if (checkoutButton) {
              checkoutButton.disabled = false;
              checkoutButton.classList.remove('disabled');
            }
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    var variantId = 40670707449905;
    this.updateCartBasedOnKit(variantId);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    var checkoutNote = document.querySelector('.cop_checkout');
    if(checkoutNote){
      if(Currency.currentCurrency == "COP"){
        checkoutNote.classList.add('hidden');
      }else{
        checkoutNote.classList.remove('hidden');
      }
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() { 
    super();
    this.collectionProdAtc = this.querySelectorAll('.cdc__prod-atc') || null;
    if (this.collectionProdAtc != null) { 
      this.collectionProdAtc.forEach(btn => btn.addEventListener('click', this.addCollectionProd.bind(this, btn)))
    }
  }

  addCollectionProd(btn) { 
    const body = JSON.stringify({
      id: Number(btn.dataset.id),
      quantity: 1,   
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.log(response.description);
      }
      
      const cartDrawer = response.sections['cart-drawer'];
      const cartCount = response.sections['cart-icon-bubble'];
      // Replace cart drawer
      const cartDrawerdestination = document.querySelector(`#CartDrawer .drawer__inner`);
      const cartDrawerSource = new DOMParser().parseFromString(cartDrawer, 'text/html').querySelector('#CartDrawer .drawer__inner').innerHTML;      
      if (cartDrawerSource && cartDrawerdestination) cartDrawerdestination.innerHTML = cartDrawerSource;

      // Replace cart icon bubble
      const cartIconBubbledestination = document.getElementById(`cart-icon-bubble`);
      const cartIconBubbleSource = new DOMParser().parseFromString(cartCount, 'text/html').querySelector('#shopify-section-cart-icon-bubble').innerHTML;
      if (cartIconBubbleSource && cartIconBubbledestination) cartIconBubbledestination.innerHTML = cartIconBubbleSource;      
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: ['.drawer__inner']
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: ['.shopify-section']
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
